import AddConnection from '@/views/AddConnection/AddConnection.vue';

export default AddConnection;
